import { render } from "./LearningContents.vue?vue&type=template&id=cc29a76a"
import script from "./LearningContents.vue?vue&type=script&lang=js"
export * from "./LearningContents.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kojimakazuya/Projects/improver-corp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__